import React from 'react'
import { colors } from 'plume-ui'

type Props = {
  date?: string
  items: TooltipItem[]
  className?: string
}

export type TooltipItem = {
  title: string
  color?: string
  dict?: TooltipDesc[]
  text?: string | null
}

export type TooltipDesc = {
  label?: string
  value: string | number | null
  unit?: string
}

// Note: React18以上だとReactDOMServer.renderToStaticMarkupでHTMLに変換された際に、
// emotionのcssが適用されないのでstyleによってスタイルを設定している
// ref: https://github.com/emotion-js/emotion/issues/3008
export const CustomTooltip: React.FC<Props> = (props) => {
  return (
    <div
      style={{
        padding: '12px 20px',
        borderRadius: '0 !important',
        backgroundColor: 'rgba(255, 255, 255, 0.5)',
      }}
      className={`custom-tooltip ${props.className ? props.className : ''}`}
    >
      <div
        style={{
          color: colors.gray70,
          fontSize: '12px',
        }}
      >
        {props.date}
      </div>
      {props.items.map((item, i) => (
        <div key={i}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginTop: i > 0 ? '15px' : '5px',
            }}
          >
            {item.color && (
              <div
                style={{
                  width: '16px',
                  height: '16px',
                  borderRadius: '50%',
                  backgroundColor: item.color,
                  opacity: 0.8,
                  marginRight: '6px',
                }}
              />
            )}
            <div
              style={{
                color: colors.text,
                fontWeight: 'bold',
                fontSize: '14px',
              }}
            >
              {item.title}
            </div>
          </div>
          {item.dict && item.dict.length > 0 && (
            <div
              style={{
                marginTop: '10px',
              }}
            >
              {item.dict?.map((d, i) => (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'start',
                    marginTop: '5px',
                    justifyContent: 'space-between',
                  }}
                  key={i}
                >
                  {d.label && (
                    <div
                      style={{
                        fontSize: '12px',
                        color: colors.text,
                      }}
                    >
                      {d.label}:
                    </div>
                  )}
                  <div
                    style={{
                      color: colors.text,
                      fontWeight: 'bold',
                      fontSize: '13px',
                      marginLeft: '3px',
                    }}
                  >
                    {d.value ?? '不明'}
                    {d.value && d.unit && (
                      <span
                        style={{
                          color: colors.gray80,
                          fontSize: '11px',
                          marginLeft: '2px',
                        }}
                      >
                        {d.unit}
                      </span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
          {item.text && (
            <div
              style={{
                marginTop: '5px',
                maxWidth: '170px',
                whiteSpace: 'pre-wrap',
                lineHeight: 1.4,
              }}
            >
              <div
                style={{
                  fontSize: '12px',
                  color: colors.text,
                }}
              >
                {item.text}
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  )
}
